import { createElement } from 'react';

import {
  ApiBlueprint,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
  PageBlueprint,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import EmojiObjectsIcon from '@mui/icons-material/EmojiObjects';

import { tomtomLabApiRef, TomtomLabClient } from './api';
import { rootRouteRef } from './routes';

const tomtomLabApi = ApiBlueprint.make({
  name: 'tomtom-lab',
  params: defineParams =>
    defineParams({
      api: tomtomLabApiRef,
      deps: {
        identityApi: identityApiRef,
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ identityApi, discoveryApi, fetchApi }) =>
        new TomtomLabClient({ identityApi, discoveryApi, fetchApi }),
    }),
});

const tomtomLabPage = PageBlueprint.make({
  name: 'tomtom-lab',
  params: {
    path: '/tomtom-lab',
    title: 'What The Hack',
    icon: createElement(EmojiObjectsIcon),
    routeRef: rootRouteRef,
    // The page supplies its own Header — the event background, the WTH logo,
    // the admin/jury chips and the local user switcher all live in that band —
    // plus a RoutedTabs bar, so opt out of the framework chrome.
    noHeader: true,
    loader: async () => {
      const { HomePage } = await import('./components/HomePage');
      return createElement(HomePage);
    },
  },
});

export const tomtomLabPlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'tomtom-lab-frontend',
  extensions: [tomtomLabApi, tomtomLabPage],
  routes: {
    root: rootRouteRef,
  },
});
